import { IHttpService } from "../HttpService";
import { IAttribute } from "../../model/formconfiguration/Attribute";
import { parseBooleanValue } from "../..";
import AttributeListMapper from "./Mappers/AttributeListMapper";
import DropdownOption, {
  IDropdownOption
} from "../../model/formconfiguration/DropdownOption";

export interface IAttributeService {
  getAttributes(): Promise<IAttribute[]>;
  createAttribute(attribute: IAttribute, formTypeCode: string): Promise<any>;
  updateAttribute(attribute: IAttribute): Promise<any>;
  invalidateAttribute(
    qualifierCode: string,
    attributeCode: string
  ): Promise<any>;
  getAttributeReferenceList(attributeCode: string): Promise<IDropdownOption[]>;
}

const AttributeService = (httpService): IAttributeService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/attributes";
  const _refPath: string = "ref";

  const ParamsMapper = (attribute: IAttribute) => {
    return {
      ...attribute,
      valid: parseBooleanValue(attribute.valid)
    };
  };

  const DropdownOptionListMapper = (json: any = []) => {
    return json.map((item: any) => DropdownOption(item));
  };

  return {
    async getAttributes() {
      const path = _http.buildPath(_baseUrl);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return AttributeListMapper(responseJSON);
    },

    async createAttribute(attribute: IAttribute, formTypeCode: string) {
      const path = _http.buildPath(_baseUrl);
      const response = await _http.post(path, {
        params: ParamsMapper(attribute),
        query: { formTypeCode }
      });
      return _http.toText(response);
    },

    async updateAttribute(attribute: IAttribute) {
      const path = _http.buildPath(_baseUrl, attribute.code);
      const response = await _http.put(path, {
        params: ParamsMapper(attribute)
      });
      return _http.toText(response);
    },

    async invalidateAttribute(qualifierCode: string, attributeCode: string) {
      const path = _http.buildPath(_baseUrl, attributeCode);
      const response = await _http.remove(path, {
        params: {
          qualifierCode
        }
      });
      return _http.toText(response);
    },

    async getAttributeReferenceList(attributeCode: string) {
      const path = _http.buildPath(_baseUrl, _refPath);
      const response = await _http.get(path, {
        params: {
          attributeCode
        }
      });
      const responseJSON = await _http.toJSON(response);
      return DropdownOptionListMapper(responseJSON);
    }
  };
};

export default AttributeService;
